import React from 'react';
import {Registration} from './container';

export const RegistrationScreen = () => {
  return <Registration />;
};
